module.exports = __webpack_public_path__ + "static/media/3d-darts.f81dc1df.jpg";